import { Controller } from "@hotwired/stimulus";

// A card's "Add to Mo" button. Queues the item as a context chip for Mo's composer
// (rendered/drained by admin--massimo--context-chips) and opens the panel on the current
// chat. Clicks accumulate, so several items can be attached, and they all ride along as
// context on the next turn the user sends. Combine with data-controller="ui--open-mo" (and
// click->ui--open-mo#open) on the same element to also start a fresh chat with a default prompt.
export default class extends Controller {
  // cards attaches several items in one click (a dashboard's failed charts); otherwise the single item below.
  static values = { label: String, sublabel: String, type: String, url: String, moNote: String, cards: Array };

  add() {
    const queue = this.#readQueue();
    const items = this.cardsValue.length ? this.cardsValue : [{
      label: this.labelValue,
      sublabel: this.sublabelValue,
      type: this.typeValue,
      url: this.urlValue,
      moNote: this.moNoteValue,
    }];
    // Stable id so the composer can drain idempotently — a chip already rendered for
    // this id is skipped, so dispatching both events below (and re-draining on a frame
    // remount) never double-adds it.
    items.forEach((item) => queue.push({ id: crypto.randomUUID(), ...item }));
    sessionStorage.setItem("massimo-context", JSON.stringify(queue));

    // Open Mo if it's closed, and tell any already-mounted composer to drain. Either
    // event alone misses a case (a reopened-but-still-mounted composer fires no connect;
    // a closed panel has no composer to hear context-added), so dispatch both — the
    // id-dedupe makes the overlap safe.
    window.dispatchEvent(new CustomEvent("massimo:open"));
    window.dispatchEvent(new CustomEvent("massimo:context-added"));
  }

  #readQueue() {
    try {
      return JSON.parse(sessionStorage.getItem("massimo-context") || "[]");
    } catch {
      return [];
    }
  }
}
